import { Button } from "@/components/elements/Button";

import styles from "./styles.module.css";

const CardUiButtonLeft = ({ children, onClick, ...rest }) => {
  return (
    <Button
      className={styles.sizeInfoButton}
      innerClassName={styles.sizeInfoButtonInner}
      theme="light"
      size="x-small"
      onClick={onClick}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default CardUiButtonLeft;
